import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useSite } from '../../context/SiteContext';

export default function ContactPage() {
  const { settings } = useSite();
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    subject: 'hop-tac',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    // In React SPA, show confirmation message
    setSubmitted(true);
  };

  return (
    <div>
      <section className="page-hero">
        <div className="container">
          <div className="crumb">
            <Link to="/">Trang chủ</Link> / <span>Liên hệ</span>
          </div>
          <span className="eyebrow">Kết nối với Thế Thảo</span>
          <h1>
            Chúng tôi luôn sẵn sàng
            <br />
            lắng nghe và đồng hành.
          </h1>
          <p className="lead">
            Dù bạn là nhà thuốc tìm nguồn hàng uy tín, ứng viên tìm kiếm cơ hội nghề nghiệp hay đối tác mong muốn hợp tác chiến lược — hãy liên hệ với chúng tôi.
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="about-grid" style={{ alignItems: 'start' }}>
            {/* Thông tin liên hệ trực tiếp */}
            <div>
              <span className="eyebrow">Thông tin liên hệ</span>
              <h2>Công ty Cổ phần Thế Thảo Pharma</h2>
              <p>Mã số thuế: <strong>0106721528</strong> · Đăng ký tại Sở Kế hoạch &amp; Đầu tư TP. Hà Nội.</p>

              <div style={{ marginTop: '28px', display: 'flex', flexDirection: 'column', gap: '20px' }}>
                <div style={{ display: 'flex', gap: '16px', alignItems: 'flex-start' }}>
                  <div className="icon-wrap" style={{ width: '48px', height: '48px', flexShrink: 0 }}>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="24" height="24">
                      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                      <circle cx="12" cy="10" r="3" />
                    </svg>
                  </div>
                  <div>
                    <h4 style={{ margin: '0 0 4px 0' }}>Trụ sở văn phòng</h4>
                    <p style={{ margin: 0, color: '#475569' }}>{settings.contact_address}</p>
                  </div>
                </div>

                <div style={{ display: 'flex', gap: '16px', alignItems: 'flex-start' }}>
                  <div className="icon-wrap" style={{ width: '48px', height: '48px', flexShrink: 0 }}>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="24" height="24">
                      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                    </svg>
                  </div>
                  <div>
                    <h4 style={{ margin: '0 0 4px 0' }}>Hotline / Zalo tư vấn</h4>
                    <p style={{ margin: 0, color: '#475569' }}>
                      Đối tác nhà thuốc (CSKH):{' '}
                      <a href={`tel:${settings.contact_phone_cskh}`} style={{ fontWeight: 600, color: '#005b31' }}>
                        {settings.contact_phone_cskh}
                      </a>
                    </p>
                    <p style={{ margin: '4px 0 0 0', color: '#475569' }}>
                      Phòng Nhân sự (Tuyển dụng):{' '}
                      <a href={`tel:${settings.contact_phone_hr}`} style={{ fontWeight: 600, color: '#005b31' }}>
                        {settings.contact_phone_hr}
                      </a>
                    </p>
                  </div>
                </div>

                <div style={{ display: 'flex', gap: '16px', alignItems: 'flex-start' }}>
                  <div className="icon-wrap" style={{ width: '48px', height: '48px', flexShrink: 0 }}>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="24" height="24">
                      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                      <polyline points="22,6 12,13 2,6" />
                    </svg>
                  </div>
                  <div>
                    <h4 style={{ margin: '0 0 4px 0' }}>Hòm thư điện tử</h4>
                    <p style={{ margin: 0 }}>
                      <a href={`mailto:${settings.contact_email}`} style={{ color: '#005b31' }}>
                        {settings.contact_email}
                      </a>
                    </p>
                  </div>
                </div>

                <div style={{ display: 'flex', gap: '16px', alignItems: 'flex-start' }}>
                  <div className="icon-wrap" style={{ width: '48px', height: '48px', flexShrink: 0 }}>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="24" height="24">
                      <circle cx="12" cy="12" r="10" />
                      <polyline points="12 6 12 12 16 14" />
                    </svg>
                  </div>
                  <div>
                    <h4 style={{ margin: '0 0 4px 0' }}>Giờ làm việc</h4>
                    <p style={{ margin: 0, color: '#475569' }}>Thứ Hai – Thứ Bảy: 8:00 – 17:30 (Chủ nhật nghỉ)</p>
                  </div>
                </div>
              </div>

              {/* Bản đồ nhúng */}
              <div style={{ marginTop: '28px', borderRadius: '12px', overflow: 'hidden', border: '1px solid #e2e8f0' }}>
                <iframe
                  title="Google Maps"
                  src="https://maps.google.com/maps?q=60B%20Nguy%E1%BB%85n%20Huy%20T%C6%B0%E1%BB%9Fng,%20Thanh%20Xu%C3%A2n,%20H%C3%A0%20N%E1%BB%99i&t=&z=15&ie=UTF8&iwloc=&output=embed"
                  width="100%"
                  height="260"
                  style={{ border: 0, display: 'block' }}
                  allowFullScreen=""
                  loading="lazy"
                />
              </div>
            </div>

            {/* Form gửi liên hệ */}
            <div className="contact-form">
              <span className="eyebrow">Để lại lời nhắn</span>
              <h3>Gửi thông tin liên hệ</h3>
              <p className="muted" style={{ marginBottom: '20px' }}>
                Chúng tôi sẽ phản hồi trong vòng 2–4 giờ làm việc.
              </p>

              {!submitted ? (
                <form onSubmit={handleSubmit} className="career-form">
                  <div className="field">
                    <label htmlFor="contactName">Họ và tên của bạn <em>*</em></label>
                    <input
                      id="contactName"
                      type="text"
                      value={formData.name}
                      onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                      placeholder="Nguyễn Văn A"
                      required
                    />
                  </div>

                  <div className="field-row">
                    <div className="field">
                      <label htmlFor="contactPhone">Số điện thoại <em>*</em></label>
                      <input
                        id="contactPhone"
                        type="tel"
                        value={formData.phone}
                        onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                        placeholder="0989 xxx xxx"
                        required
                      />
                    </div>
                    <div className="field">
                      <label htmlFor="contactEmail">Email liên hệ</label>
                      <input
                        id="contactEmail"
                        type="email"
                        value={formData.email}
                        onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                        placeholder="example@gmail.com"
                      />
                    </div>
                  </div>

                  <div className="field">
                    <label htmlFor="contactSubject">Nhu cầu liên hệ <em>*</em></label>
                    <select
                      id="contactSubject"
                      value={formData.subject}
                      onChange={(e) => setFormData({ ...formData, subject: e.target.value })}
                    >
                      <option value="hop-tac">Hợp tác phân phối nhà thuốc</option>
                      <option value="bao-gia">Yêu cầu bảng giá sản phẩm</option>
                      <option value="ung-tuyen">Ứng tuyển việc làm</option>
                      <option value="csr">Đồng hành "Tủ thuốc cho em"</option>
                      <option value="khac">Khác</option>
                    </select>
                  </div>

                  <div className="field">
                    <label htmlFor="contactMessage">Nội dung lời nhắn <em>*</em></label>
                    <textarea
                      id="contactMessage"
                      rows="4"
                      value={formData.message}
                      onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                      placeholder="Thông tin nhà thuốc, địa chỉ hoặc nội dung bạn cần hỗ trợ..."
                      required
                    />
                  </div>

                  <button
                    type="submit"
                    className="btn btn--primary"
                    style={{ width: '100%', justifyContent: 'center', marginTop: '12px' }}
                  >
                    Gửi lời nhắn
                  </button>
                </form>
              ) : (
                <div style={{ textAlign: 'center', padding: '32px 16px' }}>
                  <div style={{ fontSize: '42px', color: '#16a34a', marginBottom: '12px' }}>✓</div>
                  <h4>Cảm ơn bạn đã liên hệ!</h4>
                  <p className="muted" style={{ margin: '8px 0 20px 0' }}>
                    Đội ngũ phụ trách Thế Thảo Pharma đã ghi nhận thông tin và sẽ gọi lại cho bạn qua số điện thoại <strong>{formData.phone}</strong>.
                  </p>
                  <button
                    type="button"
                    className="btn btn--ghost"
                    onClick={() => setSubmitted(false)}
                  >
                    Gửi thêm lời nhắn khác
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
